/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../common";
import type {
  ButtonTokenWamplRouter,
  ButtonTokenWamplRouterInterface,
} from "../ButtonTokenWamplRouter";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_wampl",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "InvalidButtonAsset",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroAmount",
    type: "error",
  },
  {
    inputs: [],
    name: "wampl",
    outputs: [
      {
        internalType: "contract IWAMPL",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IButtonToken",
        name: "buttonToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "wamplBurnAndUnwrap",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IButtonToken",
        name: "buttonToken",
        type: "address",
      },
    ],
    name: "wamplBurnAndUnwrapAll",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IButtonToken",
        name: "buttonToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amplAmount",
        type: "uint256",
      },
    ],
    name: "wamplWrapAndDeposit",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type ButtonTokenWamplRouterConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ButtonTokenWamplRouterConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ButtonTokenWamplRouter__factory extends ContractFactory {
  constructor(...args: ButtonTokenWamplRouterConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _wampl: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<ButtonTokenWamplRouter> {
    return super.deploy(
      _wampl,
      overrides || {}
    ) as Promise<ButtonTokenWamplRouter>;
  }
  override getDeployTransaction(
    _wampl: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_wampl, overrides || {});
  }
  override attach(address: string): ButtonTokenWamplRouter {
    return super.attach(address) as ButtonTokenWamplRouter;
  }
  override connect(signer: Signer): ButtonTokenWamplRouter__factory {
    return super.connect(signer) as ButtonTokenWamplRouter__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ButtonTokenWamplRouterInterface {
    return new utils.Interface(_abi) as ButtonTokenWamplRouterInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ButtonTokenWamplRouter {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as ButtonTokenWamplRouter;
  }
}
